import { ExtensionProperty, IProperty, Nullable, PropertyType, vec3 } from "@gltf-transform/core3";
import { EXT_LIGHTS_IES, IES_PROFILE_MIME_TYPE } from "../constants";
import { LightProfile } from "./light-profile";

interface ILightInstance extends IProperty {
	/** The light profile referenced by this light. */
	light: LightProfile;
	/** Non-negative factor to scale the light's intensity.	*/
	multiplier: number;
	/** RGB value for the light's color in linear space. */
	color: vec3;
}

/**
 * Defines a light profile instance attached to a {@link Node}.
 * @see https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Vendor/EXT_lights_ies#adding-light-profile-instances-to-nodes
 */
export class LightInstance extends ExtensionProperty<ILightInstance> {
	public static EXTENSION_NAME = EXT_LIGHTS_IES;
	public extensionName = EXT_LIGHTS_IES;
	public propertyType = "LightInstance";
	public parentTypes = [PropertyType.NODE];

	public static MIMEType = IES_PROFILE_MIME_TYPE;

	protected init(): void {
		this.extensionName = EXT_LIGHTS_IES;
		this.propertyType = "LightInstance";
		this.parentTypes = [PropertyType.NODE];
	}

	protected getDefaults(): Nullable<ILightInstance> {
		return Object.assign(super.getDefaults() as IProperty, {
			light: null,
            multiplier: 1,
            color: [1, 1, 1] as vec3,
		});
	}

	public getLightProfile(): LightProfile | null {
		return (this as any).getRef("light");
	}

	public setLightProfile(lightProfile: LightProfile): this {
		return (this as any).setRef("light", lightProfile);
	}

    /** Non-negative factor to scale the light's intensity. */
	public getMultiplier(): number {
		return (this as any).get("multiplier");
	}

    /** Non-negative factor to scale the light's intensity. */
	public setMultiplier(multiplier: number): this {
		return (this as any).set("multiplier", multiplier);
	}

	/** RGB value for the light's color in linear space. */
	public getColor(): vec3 {
		return (this as any).get("color");
	}

	/** RGB value for the light's color in linear space. */
	public setColor(color: vec3): this {
		return (this as any).set("color", color);
	}
}